<template>
  <div>
    <span v-if="getSelectedFractionTypes(contextDictionary).length > 0" class="product-information__text-bold">{{ title }}</span>
    <div v-for="(context, key) in getSelectedFractionTypes(contextDictionary)" :id="key" :key="key">
      <!-- class="product-information__text" -->
      <b v-if="context.matched">{{ context.text }}</b>
      <span v-else>{{ context.text }}</span>
    </div>
  </div>
</template>

<script>
import fractionService from '@/core/fraction-service'
// import _ from 'lodash'

export default {
  props: {
    productId: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    vehicleName: {
      type: String,
      default: null
    },
    fractions: {
      type: Array,
      default: null
    },
    contexts: {
      type: Array,
      default: null
    },
    contextDictionary: {
      type: Object,
      default: null
    }
  },
  data: () => {
    return {
      activeContexts: []
    }
  },
  methods: {
    getSelectedFractionTypesOld(key, context) {
      return fractionService.getSelectedFractionTypesForItem(key, context, this.productId)
    },
    getSelectedFractionTypes(contexts) {
      return fractionService.getSelectedFractionTypesForItemDetailsPage(contexts, this.productId)
    }
  }
}
</script>
